export default {"src":"/_next/static/media/goal-kids.8fe2a317.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};